import * as React from 'react';
import { useEffect, useState } from "react";

import Table from 'react-bootstrap/Table';
import { Col, Container } from 'react-bootstrap';
import { ApiDelete, ApiGet } from '../../helper/API/ApiData';
import { useNavigate } from 'react-router-dom';
import { cleanData, getHeading } from '../../utils/helper';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import "primereact/resources/themes/lara-light-indigo/theme.css";
// import "primereact/resources/primereact.min.css";
// import 'primeicons/primeicons.css';

import { Button } from 'primereact/button';
import { TabPanel, TabView } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode } from 'primereact/api';
import { ToggleButton } from 'primereact/togglebutton';
import ShgDashboard from '../Dashboard/ShgDashboard';

export interface IListShgProps {

}

export const ListShg = (props: IListShgProps) => {

  const navigate = useNavigate()

  const dt = React.useRef<DataTable<any>>(null)

  const [shg, setShgs] = useState([])
  const [deletedShgs, setDeletedShgs] = useState(false)
  const [expandedRows, setExpandedRows] = useState([]);
  const [filters, setFilters] = useState<any>(null);
  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const initialVisibleColumns = [
    // {field: 'name', header: 'project_name'},
    // {field: 'project_partner', header: 'project_partner'},
    // {field: 'registration_number', header: 'registration_number'},
    // {field: 'groupMemberDetails.length', header: 'number_of_members'},
    // {field: 'name', header: 'project_name'},
    'name',
    'project_partner',
    'registration_number',
    'number_of_members',
    'total_amount_saved',
    'location',
  ]
  const [visibleColumns, setVisibleColumns] = useState(initialVisibleColumns)
  const [allColumns, setAllColumns] = useState<string[]>([])
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    ApiGet('shg')
      .then((res: any) => {
        if (res && res.status === 200) {
          if (res && res.data) {
            // const shgData = res.data.map((shg: any) => {
            //   return {
            //     ...shg,
            //     memberCount: shg.groupMemberDetails[0].members.length
            //   }
            // })
            setShgs(res.data)
            setAllColumns(Object.keys(res.data[0]))
          }
        }
      })

    initFilters();
  }, [deletedShgs])

  useEffect(() => {
    if (checked) {
      setVisibleColumns(allColumns)
    }
    else {
      setVisibleColumns(initialVisibleColumns)
    }
  }, [checked])

  const handleUpdate = (memberId: string): void => {
    navigate(`add/?id=${memberId}`)
  }

  const handleDelete = (memberId: string): void => {
    console.log("data", memberId)
    swal({
      title: "Are you sure?",
      text: "you want to delete SHG?",
      icon: "error",
      buttons: ["cancel", "ok"],
      dangerMode: true,
    }).then((result) => {
      if (result) {
        ApiDelete(`shg/${memberId}`, {})
          .then((res: any) => {
            if (res.status === 200) {
              toast.success("Successfully deleted the shg")
              // Refetch the shg list
              setDeletedShgs(!deletedShgs)
            }
          })
          .catch((error) => { return error })
      }
    })
  }

  const handleViewTraings = (shgId: string) => {
    navigate(`/shgadmin/shg/${shgId}/trainings`)
  }

  const handleViewEnterprise = (shgId: string) => {
    navigate(`/shgadmin/shg/${shgId}/enterprise`)
  }

  const handleShgDetails = (shgId: string) => {
    navigate(`/shgadmin/shg/${shgId}/shg/update`)
  }

  const header = (
    <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
      <span className="text-xxl text-900 font-bold">SHG List</span>
      <Button icon="pi pi-plus" outlined style={{ borderRadius: "50%" }} onClick={() => navigate('/shgadmin/shg/add')} />
    </div>
  );

  const clearFilter = () => {
    initFilters();
  };

  const onGlobalFilterChange = (e: any) => {
    const value = e.target.value;
    let _filters: any = { ...filters };

    _filters['global'].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    setGlobalFilterValue('');
  };

  const renderHeader = () => {
    return (
      <div className="d-flex justify-content-between">
        <div className='d-flex align-items-center justify-content-center'>
          <span className="text-xxl text-900 font-bold">SHG List</span>
          <Button icon="pi pi-plus" outlined style={{ borderRadius: "50%", marginLeft: 20 }} onClick={() => navigate('/shgadmin/shg/add')} />
        </div>
        <div className="d-flex">
          <Button type="button" className="btn btn-outline-primary me-2" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} />
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
          </span>
        </div>
      </div>
    );
  };

  const actionBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <Button tooltip='Update SHG' tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" style={{ borderRadius: "50%" }} rounded outlined className="mr-2" onClick={() => handleShgDetails(rowData.id)} />
        <Button tooltip='Delete SHG' tooltipOptions={{ position: 'top' }} icon="pi pi-trash" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="danger" onClick={() => handleDelete(rowData.id)} />
        {/* <Button tooltip='View Trainings' tooltipOptions={{ position: 'top' }} icon="pi pi-calendar" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="info" onClick={() => handleViewTraings(rowData.id)} /> */}
        {/* <Button tooltip='Add/View SHG Details' tooltipOptions={{ position: 'top' }}  icon="pi pi-briefcase" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="secondary" onClick={() => handleShgDetails(rowData.id)} /> */}
      </React.Fragment>
    );
  };
  const onRowExpand = () => {
  };

  const onRowCollapse = () => {
  };

  const handleMemberView = (groupDetailId: string) => {
    // navigate to group member details view
    navigate(`/shgadmin/group_member/${groupDetailId}/?page=home`);
  }
  const memberActionBodyTemplate = (rowData: any) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" style={{ borderRadius: "50%" }} rounded outlined className="mr-2" onClick={() => handleMemberView(rowData.groupDetail)} />
      </React.Fragment>
    );
  };

  const rowExpansionTemplate = (data: any) => {
    const currentMembers = data.groupMemberDetails.filter((groupDetail: any) => groupDetail.isActive === true).map((groupDetail: any) => {
      return {
        ...groupDetail.member,
        groupDetail: groupDetail.id,
        shg: data.id,
      }
    })
    const pastMembers = data.groupMemberDetails.filter((groupDetail: any) => groupDetail.isActive === false).map((groupDetail: any) => {
      return {
        ...groupDetail.member,
        groupDetail: groupDetail.id,
        shg: data.id,
      }
    })
    return (
      <>
        <TabView pt={{
          inkbar: {
            style: {
              display: 'none',
            }
          }
        }} >
          <TabPanel pt={{
            headerAction: {
              style: {
                textDecoration: "none",
              }
            }
          }} header="Active Members">
            <DataTable paginator rows={5} value={currentMembers} size="small" stripedRows tableStyle={{ width: "50%" }}>
              <Column field='name' header="Name"></Column>
              <Column field='age' header="Age"></Column>
              <Column field='contact_number' header="Contact number"></Column>
              <Column body={memberActionBodyTemplate} align={'center'} header="View Details"></Column>

            </DataTable>
          </TabPanel>
          <TabPanel pt={{
            headerAction: {
              style: {
                textDecoration: "none",
              }
            }
          }} header="Inactive Members">
            <DataTable paginator rows={5} value={pastMembers} size="small" tableStyle={{ width: "50%" }}>
              <Column field='name' header="Name"></Column>
              <Column field='age' header="Age"></Column>
              <Column field='contact_number' header="Contact number"></Column>
              <Column body={memberActionBodyTemplate} align={'center'} header="View Details"></Column>
            </DataTable>
          </TabPanel>
        </TabView>
      </>
    );
  };

  const exportCSV = (selectionOnly: boolean) => {
    dt.current?.exportCSV({ selectionOnly });
  };

  return (

    <Container fluid>
      {<ShgDashboard showChart={false} />}
      <div className='card p-3 m-3'>
        <DataTable
          expandedRows={expandedRows}
          ref={dt}
          onRowToggle={(e: any) => {
            setExpandedRows(e.data)
          }}
          onRowExpand={onRowExpand}
          onRowCollapse={onRowCollapse}
          rowExpansionTemplate={rowExpansionTemplate}
          value={shg}
          size="small"
          paginator
          rows={5}
          rowsPerPageOptions={[5, 10, 25, 50]}
          header={renderHeader}
          globalFilterFields={['name', 'year']}
          filters={filters}
          footer={
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                  label="Export" onClick={() => exportCSV(false)} className="w-8rem" />
                <ToggleButton
                  onLabel="Hide Columns" offLabel="Show Columns" onIcon="pi pi-eye-slash" offIcon="pi pi-eye"
                  checked={checked} onChange={(e) => setChecked(e.value)} className="w-8rem" />
                {/* <ToggleButton type="button" icon="pi pi-eye" label="View all columns" onClick={clearFilter} /> */}
              </div>
            </>
          }
        >
          <Column expander={true} style={{ width: '5rem' }} />
          {visibleColumns.length > 0 && visibleColumns.map((shgField, index) => {
            if (shgField !== 'id' && shgField !== 'slug' && shgField !== 'groupMemberDetails') {
              return (
                <Column style={{ width: "300px" }} key={shgField} field={shgField} header={getHeading(shgField)}></Column>
              )
            }
          })}
          {/* {shg.length > 0 && <Column field="groupMemberDetails.length" header="Number of members"></Column>} */}


          <Column body={actionBodyTemplate} style={{ minWidth: '10rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
        </DataTable>
      </div>
    </Container>
  );
}

